import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()
    
    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    return (
        <div
            class="nosto-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-w-100 ns-left-0"
            data-nosto-element="autocomplete"
        >
            <div class="nosto-autocomplete-content ns-w-100 ns-mt-sm-auto">
                <div class="nosto-autocomplete-sections ns-d-flex ns-flex-column ns-flex-sm-row">
                    {keywords?.hits?.length > 0 && (
                        <div
                            class={`nosto-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? "nosto-autocomplete-keywords-with-products ns-col-sm-4" : "nosto-autocomplete-keywords-only ns-col-sm-12"
                            }`}
                        >
                            <div class="nosto-autocomplete-keywords-list ns-d-flex ns-flex-column">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!products?.hits?.length && <SubmitButton className={'P-18 ns-my-4'} text="See all search results" />}
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="nosto-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="nosto-autocomplete-products-list ns-d-flex ns-flex-column">
                                {products?.hits?.map(hit => {
                                    return (
                                        <AutocompleteElement hit={hit}>
                                            <div
                                                data-url={hit.url}
                                                class="nosto-autocomplete-product ns-d-flex ns-clickable ns-p-2 ns-mb-4"
                                                data-nosto-element="product"
                                            >
                                                <img
                                                    class="nosto-autocomplete-product-image ns-h-auto ns-object-contain"
                                                    src={hit.imageUrl ?? productImagePlaceholder}
                                                    alt={hit.name}
                                                    width="80"
                                                    height="80"
                                                />
                                                <div class="nosto-autocomplete-product-details ns-pl-2">
                                                    <div class="nosto-autocomplete-product-name">
                                                        <div class="card__heading H-18">
                                                            {hit.name.split(' - ')[0]}
                                                        </div>
                                                        {hit.name.includes(' - ') && (
                                                            <div class="card__subheading H-16-alt">
                                                                {hit.name.split(' - ')[1]}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div class="nosto-autocomplete-product-price price price-new">
                                                        <div class="price__regular price__regular-new">
                                                          <span class="price-item price-item--regular H-16">{format(hit.price)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                            <SubmitButton className={'P-18 ns-my-4'} text="See all search results" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span class="nosto-autocomplete-keyword P-18" data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="nosto-autocomplete-element ns-clickable P-18">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="nosto-autocomplete-keyword-category ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="nosto-autocomplete-keyword-category-text P-18">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
